var React = require('react');

function Petal (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Frame"},React.createElement("g",{"id":"Group"},React.createElement("path",{"id":"Vector","d":"M91 13V21.6667C91 63.3837 67.717 82.3333 39 82.3333H30.758C31.6767 69.2813 35.7413 61.3817 46.3493 51.9957C51.5667 47.3807 51.1247 44.7157 48.555 46.2453C30.8577 56.7753 22.0697 71.006 21.6797 93.73L21.6667 95.3333H13C13 89.427 13.5027 84.0667 14.4993 79.1613C13.5027 73.554 13 65.9447 13 56.3333C13 32.4003 32.4003 13 56.3333 13C65 13 73.6667 17.3333 91 13Z","fill":"#55AF9E"}))));
}

Petal.defaultProps = {"width":"104","height":"104","viewBox":"0 0 104 104","fill":"none"};

module.exports = Petal;

Petal.default = Petal;
